
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/teleport-alternative",
      function () {
        return require("private-next-pages/compare/teleport-alternative.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/teleport-alternative"])
      });
    }
  